/*
  House of Silver Motion Engine — hos-motion.js
  Standalone from rc-cinema.js (Vault's engine): own selectors
  (data-hos-reveal / data-hos-stagger / data-hos-split), own
  reveal class (.hos-in), own word-split markup (.hos-w/.hos-wi).
  Applies the two hard lessons already learned building rc-cinema
  on this project: (1) force a reflow between splitting words and
  observing them, so an already-in-viewport headline's transition
  can't fire before its pre-reveal state was ever painted; (2) a
  hard fallback timeout guarantees content is never stuck invisible
  even if the IntersectionObserver never fires.
*/
(function () {
  if (window.__hosMotion) return;
  window.__hosMotion = true;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function splitWords(el) {
    var walk = function (node) {
      var kids = Array.prototype.slice.call(node.childNodes);
      kids.forEach(function (child) {
        if (child.nodeType === 3) {
          var frag = document.createDocumentFragment();
          child.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
            var w = document.createElement('span');
            w.className = 'hos-w';
            var inner = document.createElement('span');
            inner.className = 'hos-wi';
            inner.textContent = part;
            w.appendChild(inner);
            frag.appendChild(w);
          });
          child.parentNode.replaceChild(frag, child);
        } else if (child.nodeType === 1 && child.tagName !== 'BR') {
          walk(child);
        }
      });
    };
    walk(el);
    var words = el.querySelectorAll('.hos-wi');
    for (var i = 0; i < words.length; i++) {
      var delay = i * 55 + 'ms';
      words[i].style.transitionDelay = delay;
      words[i].style.animationDelay = delay;
    }
  }

  if (reduced) {
    var settle = function () {
      document.querySelectorAll('[data-hos-reveal],[data-hos-stagger],[data-hos-split]').forEach(function (el) {
        el.classList.add('hos-in');
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', settle, { once: true });
    else settle();
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('hos-in');
      io.unobserve(e.target);
      if (e.target.hasAttribute('data-hos-split')) {
        window.setTimeout(function () {
          var words = e.target.querySelectorAll('.hos-wi');
          for (var i = 0; i < words.length; i++) words[i].style.transform = 'translateY(0) rotate(0deg)';
        }, 1400);
      }
    });
  }, { rootMargin: '10% 0px -6% 0px', threshold: 0.05 });

  function tag() {
    document.querySelectorAll('[data-hos-split]:not([data-hos-tagged])').forEach(function (el) {
      el.setAttribute('data-hos-tagged', '');
      splitWords(el);
      void el.offsetWidth;
      io.observe(el);
    });
    document.querySelectorAll('[data-hos-reveal]:not([data-hos-tagged]), [data-hos-stagger]:not([data-hos-tagged])').forEach(function (el) {
      el.setAttribute('data-hos-tagged', '');
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tag, { once: true });
  else tag();

  var pending = false;
  function scheduleTag() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(function () {
      pending = false;
      tag();
    });
  }
  var mo = new MutationObserver(scheduleTag);
  mo.observe(document.body, { childList: true, subtree: true });
})();
